var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-language",
    "data-name": "Icon material-language",
    d: "M14.988,3A12,12,0,1,0,27,15,11.994,11.994,0,0,0,14.988,3ZM23.3,10.2h-3.54a18.779,18.779,0,0,0-1.656-4.272A9.636,9.636,0,0,1,23.3,10.2ZM15,5.448A16.9,16.9,0,0,1,17.292,10.2H12.708A16.9,16.9,0,0,1,15,5.448ZM5.712,17.4a9.387,9.387,0,0,1,0-4.8H9.768A19.818,19.818,0,0,0,9.6,15a19.818,19.818,0,0,0,.168,2.4ZM6.7,19.8h3.54a18.779,18.779,0,0,0,1.656,4.272A9.584,9.584,0,0,1,6.7,19.8Zm3.54-9.6H6.7a9.584,9.584,0,0,1,5.2-4.272A18.779,18.779,0,0,0,10.236,10.2ZM15,24.552A16.9,16.9,0,0,1,12.708,19.8h4.584A16.9,16.9,0,0,1,15,24.552ZM17.808,17.4H12.192A17.655,17.655,0,0,1,12,15a17.5,17.5,0,0,1,.192-2.4h5.616A17.5,17.5,0,0,1,18,15,17.656,17.656,0,0,1,17.808,17.4Zm.3,6.672A18.779,18.779,0,0,0,19.764,19.8H23.3a9.636,9.636,0,0,1-5.2,4.272ZM20.232,17.4A19.817,19.817,0,0,0,20.4,15a19.818,19.818,0,0,0-.168-2.4h4.056a9.387,9.387,0,0,1,0,4.8Z",
    transform: "translate(-3 -3)",
    fill: "#293462"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/LanguageIcon.6608d3f3c0bb62f41c0265f96493eb2f.svg";
export { ForwardRef as ReactComponent };